module.exports = new __parcel__URL__("shop_common_se_refill_image.bbc14b04.png").toString();